import { getAccessToken } from '@/services/axios-instance';
import { LanguagesEnum } from '../enums/Languages';
import { parseAuthToken } from './token';

export const languageOptions = [
  {
    key: LanguagesEnum.Turkish,
    label: 'Türkçe',
    flag: '/flags/tr.svg',
  },
  {
    key: LanguagesEnum.English,
    label: 'English',
    flag: '/flags/gb.svg',
  },
  {
    key: LanguagesEnum.Azerbaijan,
    label: 'Azərbaycan dili',
    flag: '/flags/az.svg',
  },
  {
    key: LanguagesEnum.Russian,
    label: 'Русский язык',
    flag: '/flags/ru.svg',
  },
  {
    key: LanguagesEnum.Kyrgyz,
    label: 'Кыргыз тили',
    flag: '/flags/kg.svg',
  },
  {
    key: LanguagesEnum.Uzbek,
    label: 'Ozbek tili',
    flag: '/flags/uz.svg',
  },
  {
    key: LanguagesEnum.Kazakh,
    label: 'Қазақ тілі',
    flag: '/flags/kz.svg',
  },
];
/**
 * Get the language preference:
 * 1. LocalStorage (client-side only)
 * 2. Access token
 * 3. Default to Turkish
 * @returns {LanguagesEnum} The preferred language
 */
export const getLanguage = (): LanguagesEnum => {
  // Check if we're in a browser environment
  if (typeof window !== 'undefined') {
    // First check localStorage
    const storedLang = localStorage.getItem('language') as LanguagesEnum;
    if (storedLang && Object.values(LanguagesEnum).includes(storedLang)) {
      return storedLang;
    }
  }

  // If not in localStorage or not in browser, check token
  const parsedAuthToken = parseAuthToken(getAccessToken());
  if (parsedAuthToken?.lang) {
    return parsedAuthToken.lang as LanguagesEnum;
  }

  // Default to Turkish
  return LanguagesEnum.Turkish;
};
